<template>
  <a-row :gutter="16">
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-range-picker v-model:value="queryForm.daterange" :locale="locale" value-format="YYYY-MM-DD"
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.type" :options="qtypes" style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="refresh">查询</a-button>
    </a-col>
  </a-row>
  <div class="static mt-2 mb-2">
    <a-row>
      <a-col :span="5">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">总金额</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="总金额" :precision="2" :value="total_amount" />
      </a-col>
      <a-col :span="5">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">人员工资</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="人员工资" :precision="2" :value="total_amount1" />
      </a-col>
      <a-col :span="5">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">采购费用</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="采购费用" :precision="2" :value="total_amount2" />
      </a-col>
      <a-col :span="5">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">物流费用</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="物流费用" :precision="2" :value="total_amount3" />
      </a-col>
      <a-col :span="4">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">提现金额</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="提现金额" :precision="2" :value="total_amount4" />
      </a-col>
    </a-row>
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{ current: page, pageSize: limit, total: count, showQuickJumper: true, showSizeChanger: true, showTotal: (total) => `共${total}条`, }"
    @change="(pagination) => { page = pagination.current; limit = pagination.pageSize; }" row-key="_id"
    :row-selection="{ selectedRowKeys, onChange: (keys) => (selectedRowKeys = keys), }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'type'">
        {{ gettype(record.type) }}
      </template>
      <template v-if="column.dataIndex === 'amount'">
        {{ record.amount }} {{ record.currency }}
      </template>
      <template v-if="column.dataIndex === 'supplier'">
        {{ getsupplier(record.supplierid) || '-' }}
      </template>
      <template v-if="column.dataIndex === 'pay_time'">
        {{ record.pay_time || '-' }}
      </template>
      <template v-if="column.dataIndex === 'pay_state'">
        <a-tag v-if="record.pay_state === 0" color="processing">待支付</a-tag>
        <a-tag v-else-if="record.pay_state === 1" color="success">已支付</a-tag>
        <span v-else>-</span>
      </template>
    </template>
  </a-table>
</template>
<script setup>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, onActivated, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { title: "商户", dataIndex: "org", width: 100 },
  { title: "费用类型", dataIndex: "type", width: 100 },
  { title: "支付金额", dataIndex: "amount", width: 150 },
  { title: "供应商", dataIndex: "supplier", width: 150 },
  { title: "支付状态", dataIndex: "pay_state", width: 100 },
  { title: "支付时间", dataIndex: "pay_time", width: 150 },
];
const { proxy } = getCurrentInstance();
const queryForm = ref({
  daterange: ["", ""],
  orgid: "ALL",
  type: "ALL",
});
const dataLoading = ref(false);
const loading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const total_amount = ref(0);
const total_amount1 = ref(0);
const total_amount2 = ref(0);
const total_amount3 = ref(0);
const total_amount4 = ref(0);
const selectedRowKeys = ref([]);
const orgs = ref([]);
const types = ref([
  { value: "1", label: "人员工资" },
  { value: "2", label: "采购费" },
  { value: "3", label: "物流费" },
  { value: "4", label: "提现" },
]);
const suppliers = ref([]);

const qtypes = computed(() => {
  return [
    { value: 'ALL', label: '全部类型' },
    ...types.value,
  ]
});
const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  refresh();
});
const refresh = () => {
  getData();
  getStatistics();
}
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/payreq/list2", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, (n) => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, "YYYY-MM-DD HH:mm:ss"),
        };
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
      types.value = res.data.types;
      suppliers.value = res.data.suppliers;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const getStatistics = () => {
  loading.value = true;
  proxy.$api.doAPI("/payreq/statistics", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    loading.value = false;
    if (res.code === 0) {
      total_amount.value = res.data.total_amount;
      total_amount1.value = res.data.total_amount1;
      total_amount2.value = res.data.total_amount2;
      total_amount3.value = res.data.total_amount3;
      total_amount4.value = res.data.total_amount4;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    loading.value = false;
    console.error(err);
  });
};
const getorgname = (value) => {
  return _.findWhere(orgs.value, { _id: value })?.name;
}
const gettype = (value) => {
  return _.findWhere(types.value, { value })?.label;
}
const getsupplier = (value) => {
  let supplier = _.findWhere(suppliers.value, { _id: value });
  return supplier?.shortname || supplier?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>
